import React, { useEffect, useState } from "react";
import pauserecord from "../images/poserecord.svg";
import stoprecord from "../images/stoprecord.svg";
import mic from "../images/mic.svg";
// import Timer from "../../../helper/Timer";
import { clearConsole } from "../../../helper/CommonFuncs";
import "../AllNotes.css";
import close from "../images/close.svg";
import { stopRecordingMain } from "../../../redux/actions/note.action";
import { ShowAlert } from "../../../common/alert";
import EpicHeader from "../../epic/components/EpicHeader";
import Timewatch from "../../notes/component/TimeWatch";
let rec;
let stream = null;
let audioFile = null;
// let audioPlayer = new Audio();
// let counter = new Timer();
let timerLabel;
let data = [];
let streams = [];
let startBtn;
let stopBtn;
let pauseBtn;
let animFrame;
export const Audio = (props) => (
   <audio
      controls
      className="shadow round-border-l"
      onError={() => {
         clearConsole();
      }}
      controlsList="nodownload"
      {...props}
   />
);
async function createNode(h) {
   if (document.getElementsByClassName("visualizer-div-epic").length > 0) {
      const visualizerDiv = document.getElementsByClassName("visualizer-div-epic")[0];

      // Ensure only 15 nodes are created
      const existingNodes = visualizerDiv.getElementsByClassName("visualizer-node");
      if (existingNodes?.length >= 100) {
         // Remove excess nodes
         while (existingNodes?.length > 50) {
            existingNodes[0].remove();
         }
      }

      let node = document.createElement("div");
      node.style.width = "8px";
      node.style.height = `${h}px`;
      node.className = " visualizer-node bg-primary rounded-top rounded-bottom m-3 float-left flex-shrink-0 ";

      let visualizer = document.getElementsByClassName("visualizer-div-epic")[0] || false;
      if (visualizer) {
         visualizer && visualizer.appendChild(node);
         visualizer.scrollLeft += 100;
      }
   }
}
async function visualise() {
   if (!stream) return;
   var audioContext = new (window.AudioContext || window.webkitAudioContext)();
   var analyser = audioContext.createAnalyser();
   var dataArray = new Uint8Array(analyser.frequencyBinCount);

   if (stream instanceof Blob) {
      const arrayBuffer = await new Response(stream).arrayBuffer();
      const audioBuffer = await audioContext.decodeAudioData(arrayBuffer);
      source = audioContext.createBufferSource();
      source.buffer = audioBuffer;
      source.connect(analyser);
      source.start(0);
   } else {
      var source = audioContext.createMediaStreamSource(stream);
      source.connect(analyser);
   }
   analyser.fftSize = 64;
   var bufferLength = analyser.fftSize;
   var dataArray = new Uint8Array(bufferLength);
   var viz = () => {
      analyser.getByteFrequencyData(dataArray);
      let val = dataArray.reduce((prev, curr) => prev + curr) / 64;
      createNode(val);
      createNode(dataArray[12]);
      createNode(dataArray[21]);
      createNode(dataArray[42]);
      animFrame = requestAnimationFrame(viz);
   };
   viz();
}
function startRecorder(onstop, startStopWatch = () => {}, uploadMediaV2 = () => {}, onPermissionNotAllowed = () => {}) {
   navigator.mediaDevices
      .getUserMedia({ audio: true })
      .then((mediaStream) => {
         stream = mediaStream;
         streams.push(mediaStream);
         visualise();
         const recorder = new MediaRecorder(mediaStream);
         rec = recorder;
         let timeoutId;
         let chunks = [];

         // Setup event listeners for the recorder
         recorder.ondataavailable = (e) => chunks.push(e.data);
         recorder.onstop = (e) => {
            uploadMediaV2(new Blob(chunks));
            clearTimeout(timeoutId);
            chunks = [];
            if (!localStorage.getItem("recordingPaused")) {
               startRecording();
               stream = mediaStream;
            }
            if (localStorage.getItem("isFinal")) {
               streams.forEach((stream) => {
                  stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
               });
               // mediaStream && mediaStream.getTracks().forEach((track) => track.stop());
            }
         };

         startStopWatch();

         const startRecording = () => {
            recorder.start();
            stream = mediaStream;
            timeoutId = setTimeout(() => {
               recorder.stop();
            }, 30000);
         };

         // Start the recorder initially
         startRecording();
      })
      .catch((error) => {
         setTimeout(() => {
            onPermissionNotAllowed();
         }, 1000);
         ShowAlert("Please allow microphone permissions", "error");

         // Handle the error here, such as displaying a message to the user
         console.error("Error accessing microphone:", error);
      });
}

const RecordingNoteComp = (props) => {
   const {
      onStart,
      onStop,
      onPause,
      onResume,
      setIsRecording,
      setIsStartRecording,
      discardRecording,
      setShowComponent,
      showBanner,
      removeRecordingFromUrl,
      noteId,
      uploadMediaV2 = () => {},
      initialTime = "",
      setInitialTime,
      onPermissionNotAllowed,
      patientDetails,
   } = props;
   const [showRecorder, setShowRecorder] = useState(true);
   const [loader, setLoader] = useState(false);
   const [getsecond, setGetSecond] = useState({ seconds: 0, minutes: 0 });
   const [state, setstate] = useState({
      isRecording: false,
      isPaused: false,
      isBlocked: false,
   });
   const [stopWatch, setStopWatch] = useState({
      start: false,
      pause: false,
      stop: false,
      play: false,
   });
   useEffect(() => {
      localStorage.removeItem("stopWatch");
      localStorage.removeItem("intervalStart");
      startBtn = document.getElementById("btn-start-video");
      startBtn.onclick = () => {};
      stopBtn = document.getElementById("btn-stop-video");
      stopBtn.onclick = () => {
         localStorage.setItem("recordingPaused", "true");
         cancelAnimationFrame(animFrame);
         rec.stop();
         setstate({ ...state, isRecording: false, isPaused: false });
         setStopWatch({ start: false, pause: false, stop: true, play: false });
         removeRecordingFromUrl();
         stopRecordingMain();
         onStop && onStop("");
         localStorage.setItem("isFinal", "true");
         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
         });
      };
      pauseBtn = document.getElementById("btn-pause-video");
      pauseBtn.onclick = () => {
         if (rec.state === "recording") {
            localStorage.setItem("recordingPaused", "true");
            rec.stop();
            cancelAnimationFrame(animFrame);
            setstate({
               ...state,
               isPaused: true,
               isRecording: false,
            });
            setStopWatch({
               start: false,
               pause: true,
               stop: false,
               play: false,
            });
            let stop = localStorage.getItem("intervalStart");
            if (stop && stop === "true") {
               localStorage.setItem("stopWatch", "true");
               localStorage.removeItem("intervalStart");
            }
            setIsRecording(false);
         } else {
            localStorage.removeItem("recordingPaused");
            startRecorder(
               onStop,
               () => {
                  setStopWatch({ start: false, pause: false, stop: false, play: true });
               },
               uploadMediaV2
            );
            setIsRecording(true);
            startBtn.style.display = "none";
            stopBtn.style.display = "initial";
            pauseBtn.style.display = "initial";
            setstate({ ...state, isRecording: true, isPaused: false });
         }
      };
      startBtn?.click();
      return () => {
         cancelAnimationFrame(animFrame);
         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
         });
      };
   }, []);
   useEffect(() => {
      localStorage.removeItem("isFinal");
      localStorage.removeItem("recordingPaused");
      localStorage.removeItem("uploadingPending");
      startRecorder(
         onStop,
         () => {
            setStopWatch({ start: true, pause: false, stop: false, play: false });
         },
         uploadMediaV2,
         onPermissionNotAllowed
      );
      return () => {
         cancelAnimationFrame(animFrame);
         streams.forEach((stream) => {
            stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
         });
      };
   }, []);

   const handlePauseNext = () => {
      localStorage.setItem("isFinal", "true");
      localStorage.removeItem("recordingPaused");
      setLoader(true);
      streams.forEach((stream) => {
         stream.getTracks().forEach((track) => track.stop()); // Stop all tracks in each stream
      });
      setTimeout(() => {
         uploadMediaV2(new Blob([]));
         setstate({ ...state, isRecording: false, isPaused: false });
         setStopWatch({ start: false, pause: false, stop: true, play: false });
         removeRecordingFromUrl();
         stopRecordingMain();
         onStop && onStop("");
      }, 1000);
   };
   return (
      <div className=" w-100 main-container-recording-epic-title">
         <div className={` realtive-cont-v2-app custom-card-banner-epic no-scrollbar `}>
            <img onClick={discardRecording} src={close} alt="close" className="cross-box-epic cursor-pointer" />
            {patientDetails && (
               <div className="epic-header-margin-extra">
                  <EpicHeader patientDetails={patientDetails} />
               </div>
            )}
            {/* <div className="recording-note-text">Recording Note</div> */}
            <div className="d-flex align-items-center container-recording-visualizer-epic ">
               <div
                  id="btn-start-video"
                  className={` w-100 visualizer-epic-container-main-v2 ${
                     !state.isPaused ? "visualizer-div-epic" : "visualizer-div-false"
                  } d-flex align-items-center custom-height-v2-version overflow-auto scroll-bar-audio-recorder`}
               >
                  {!state.isRecording ? <div style={{ height: "5px" }} className="bg-white" /> : null}
               </div>
            </div>
            <div className="recording-time-text">
               <Timewatch
                  setInitialTime={setInitialTime}
                  initialTime={initialTime}
                  noteId={noteId}
                  stopWatch={stopWatch}
                  setGetSecond={setGetSecond}
               />
            </div>
            <div className="search-flex-container relative">
               <img
                  onClick={() => setShowRecorder(!showRecorder)}
                  id="btn-pause-video"
                  src={state.isPaused ? mic : pauserecord}
                  alt="poserecord"
                  className={`cursor-pointer  ${!showRecorder ? "d-block " : "d-block  margin-recording"}`}
               />
               <img
                  id="btn-stop-video"
                  src={stoprecord}
                  alt="stoprecord"
                  className={`cursor-pointer ${showRecorder ? "d-block  margin-recording" : "d-none"}`}
               />
            </div>
            {state.isPaused && (
               <div
                  onClick={() => {
                     if (!loader) {
                        handlePauseNext();
                     }
                  }}
                  className="next-container cursor-pointer d-flex justify-items-center text-center justify-content-center"
               >
                  <div className="next-text text-center">{loader ? "loading..." : "Submit"}</div>
               </div>
            )}
         </div>
      </div>
   );
};

export default RecordingNoteComp;
